import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function SmokeAlarmsPage() {
  const serviceData = {
    title: 'Smoke Alarm Installation & Testing',
    subtitle: 'Life-Saving Fire Protection',
    description: 'Protect your family and property with professionally installed and maintained smoke alarms. We ensure compliance with Australian standards, provide regular testing services, and install interconnected photoelectric smoke alarms for maximum safety.',
    heroImage: 'https://public.readdy.ai/ai/img_res/24f2b8cee22c8a5b0c01ae11d7099e50.jpg',
    features: [
      {
        icon: 'ri-alarm-warning-line',
        title: 'Photoelectric Alarms',
        description: 'Latest technology for early fire detection'
      },
      {
        icon: 'ri-links-line',
        title: 'Interconnected Systems',
        description: 'All alarms sound when one detects smoke'
      },
      {
        icon: 'ri-checkbox-circle-line',
        title: 'Compliance Testing',
        description: 'Regular testing to meet legal requirements'
      },
      {
        icon: 'ri-battery-charge-line',
        title: '10-Year Batteries',
        description: 'Long-life lithium battery installations'
      }
    ],
    benefits: [
      'Photoelectric smoke alarm installation',
      'Interconnected alarm systems',
      'Hardwired and battery options',
      'Compliance with AS 3786',
      'Regular testing and maintenance',
      'Battery replacement services',
      'Rental property compliance',
      'Certificate of compliance provided'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Property Assessment',
        description: 'Evaluate layout and determine optimal alarm locations'
      },
      {
        number: '02',
        title: 'Installation',
        description: 'Professional mounting and interconnection of alarms'
      },
      {
        number: '03',
        title: 'Testing',
        description: 'Comprehensive testing of all alarm functions'
      },
      {
        number: '04',
        title: 'Certification',
        description: 'Provide compliance certificate and maintenance advice'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}